import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Message } from 'semantic-ui-react';

class MessageBlock extends Component {
    renderContent() {
        const { content } = this.props;

        if (content && content !== '') {
            return <p>{content}</p>;
        }
        return null;
    }
    render() {
        const { title } = this.props;
        return (
            <Message success>
                <Message.Header>{title}</Message.Header>
                {this.renderContent()}
            </Message>
        );
    }
}

MessageBlock.propTypes = {
    title: PropTypes.any.isRequired,
    content: PropTypes.any
};

MessageBlock.defaultProps = {
    content: ''
};

export default MessageBlock;
